import {
  PERSONA_IDS,
  PERSONA_REGISTRY,
  getActivationCriteriaForPersona,
  getAllPersonas,
  getPersona
} from "../chunk-5MHEHJ4Z.js";

// src/persona/classifier.ts
function classifyPersona(answers) {
  const { primaryChannel, monthlyVolume, primaryPurpose, teamSize } = answers;
  if (primaryChannel === "developer" || primaryPurpose === "integration") {
    return "developer";
  }
  if (primaryChannel === "agency" || teamSize === "large") {
    return "agency-consultant";
  }
  if (primaryChannel === "influencer") {
    return "influencer";
  }
  if (primaryChannel === "smartstore" || primaryPurpose === "sales") {
    return "ecommerce-seller";
  }
  if (primaryChannel === "blog" || primaryChannel === "other") {
    if (primaryPurpose === "analysis" && monthlyVolume === "high") {
      return "seo-expert";
    }
    if ((monthlyVolume === "medium" || monthlyVolume === "high") && (primaryPurpose === "brand" || primaryPurpose === "analysis") && teamSize !== "solo") {
      return "power-blogger";
    }
    if (monthlyVolume === "high" && primaryPurpose === "traffic") {
      return "power-blogger";
    }
    return "beginner-blogger";
  }
  return "beginner-blogger";
}
var ONBOARDING_QUESTIONS = [
  {
    key: "primaryChannel",
    label: "\uC8FC\uB85C \uC5B4\uB5A4 \uCC44\uB110\uC744 \uC6B4\uC601\uD558\uC2DC\uB098\uC694?",
    options: [
      {
        value: "blog",
        label: "\uBE14\uB85C\uADF8",
        description: "\uB124\uC774\uBC84 \uBE14\uB85C\uADF8, \uD2F0\uC2A4\uD1A0\uB9AC \uB4F1"
      },
      {
        value: "smartstore",
        label: "\uC2A4\uB9C8\uD2B8\uC2A4\uD1A0\uC5B4",
        description: "\uB124\uC774\uBC84 \uC1FC\uD551/\uC2A4\uB9C8\uD2B8\uC2A4\uD1A0\uC5B4"
      },
      {
        value: "influencer",
        label: "\uC778\uD50C\uB8E8\uC5B8\uC11C",
        description: "\uB124\uC774\uBC84 \uC778\uD50C\uB8E8\uC5B8\uC11C \uCC44\uB110"
      },
      {
        value: "agency",
        label: "\uB9C8\uCF00\uD305 \uB300\uD589",
        description: "\uC5EC\uB7EC \uD074\uB77C\uC774\uC5B8\uD2B8 \uAD00\uB9AC"
      },
      {
        value: "developer",
        label: "\uAC1C\uBC1C\uC790/API",
        description: "API \uC5F0\uB3D9, \uB370\uC774\uD130 \uBD84\uC11D"
      },
      { value: "other", label: "\uAE30\uD0C0", description: "\uC704\uC5D0 \uD574\uB2F9 \uC5C6\uC74C" }
    ]
  },
  {
    key: "monthlyVolume",
    label: "\uC6D4 \uCF58\uD150\uCE20/\uC0C1\uD488 \uBC1C\uD589 \uADDC\uBAA8\uB294?",
    options: [
      { value: "low", label: "\uC18C\uADDC\uBAA8", description: "\uC6D4 10\uAC74 \uBBF8\uB9CC" },
      { value: "medium", label: "\uC911\uADDC\uBAA8", description: "\uC6D4 10~50\uAC74" },
      { value: "high", label: "\uB300\uADDC\uBAA8", description: "\uC6D4 50\uAC74 \uC774\uC0C1" }
    ]
  },
  {
    key: "primaryPurpose",
    label: "\uAC00\uC7A5 \uC911\uC694\uD55C \uBAA9\uC801\uC740 \uBB34\uC5C7\uC778\uAC00\uC694?",
    options: [
      {
        value: "traffic",
        label: "\uAC80\uC0C9 \uD2B8\uB798\uD53D",
        description: "\uBC29\uBB38\uC790\xB7\uB178\uCD9C \uC99D\uAC00"
      },
      {
        value: "sales",
        label: "\uC0C1\uD488 \uD310\uB9E4",
        description: "\uC804\uD658\uC728\xB7\uB9E4\uCD9C \uC99D\uAC00"
      },
      {
        value: "brand",
        label: "\uBE0C\uB79C\uB4DC \uC778\uC9C0\uB3C4",
        description: "\uCC44\uB110 \uC131\uC7A5\xB7\uD314\uB85C\uC6CC"
      },
      {
        value: "analysis",
        label: "\uB370\uC774\uD130 \uBD84\uC11D",
        description: "\uC778\uC0AC\uC774\uD2B8\xB7\uB9AC\uD3EC\uD2B8"
      },
      {
        value: "integration",
        label: "API \uC5F0\uB3D9",
        description: "\uC790\uC0AC \uC2DC\uC2A4\uD15C \uD1B5\uD569"
      }
    ]
  },
  {
    key: "teamSize",
    label: "\uD300 \uADDC\uBAA8\uB294?",
    options: [
      { value: "solo", label: "\uD63C\uC790", description: "\uAC1C\uC778 \uC6B4\uC601" },
      { value: "small", label: "\uC18C\uADDC\uBAA8 \uD300", description: "2~9\uBA85" },
      { value: "large", label: "\uB300\uADDC\uBAA8 \uD300", description: "10\uBA85 \uC774\uC0C1" }
    ]
  }
];

// src/persona/store.ts
var STORAGE_KEY = "datalab_persona_id";
function isValidPersonaId(value) {
  return typeof value === "string" && PERSONA_IDS.includes(value);
}
function getCurrentPersona() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw && isValidPersonaId(raw)) return raw;
  } catch {
  }
  return null;
}
function setCurrentPersona(id) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, id);
  } catch {
  }
}
function clearPersona() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
  }
}

// src/persona/layout-map.ts
var PERSONA_LAYOUT_DEFAULTS = {
  "beginner-blogger": "agent-first",
  // P1 민지 — AI 대화 중심
  "power-blogger": "split-view",
  // P2 승현 — AI + 상세 교차 (lg+ 에서만)
  "seo-expert": "detail-first",
  // P3 정우 — 상세 데이터 직접 탐색
  "ecommerce-seller": "agent-first",
  // P4 수아 — AI 대화로 빠른 답변
  "agency-consultant": "split-view",
  // P5 하은 — AI + 관리 화면 교차 (lg+ 에서만)
  influencer: "agent-first",
  // P6 도윤 — AI 대화 + 채널 상세
  developer: "detail-first"
  // P7 재호 — 상세/API 직접 탐색
};
var PERSONA_AGENT_DEFAULTS = {
  "beginner-blogger": "dashboard-briefer",
  // P1 민지 — 브리핑부터 시작
  "power-blogger": "content-auditor",
  // P2 승현 — 콘텐츠 감사
  "seo-expert": "full-analyst",
  // P3 정우 — 종합 분석
  "ecommerce-seller": "keyword-analyst",
  // P4 수아 — 키워드 분석
  "agency-consultant": "full-analyst",
  // P5 하은 — 종합 분석
  influencer: "channel-scout",
  // P6 도윤 — 채널 스카우트
  developer: "full-analyst"
  // P7 재호 — 종합 분석 (API 연동 후)
};
function getPersonaLayoutMode(personaId, windowWidth = typeof window !== "undefined" ? window.innerWidth : 1280) {
  const preferred = PERSONA_LAYOUT_DEFAULTS[personaId];
  if (preferred === "split-view" && windowWidth < 1024) {
    return "agent-first";
  }
  return preferred;
}
function getPersonaAgentId(personaId) {
  return PERSONA_AGENT_DEFAULTS[personaId] ?? PERSONA_REGISTRY[personaId].preferredAgentId;
}

// src/persona/system-prompt-builder.ts
var HELP_DENSITY_INSTRUCTIONS = {
  high: "\uC804\uBB38 \uC6A9\uC5B4\uB97C \uC26C\uC6B4 \uB9D0\uB85C \uD480\uC5B4 \uC124\uBA85\uD558\uACE0, \uAC01 \uC218\uCE58\uC758 \uC758\uBBF8\uC640 \uD65C\uC6A9 \uBC29\uBC95\uC744 \uD568\uAED8 \uC548\uB0B4\uD558\uC138\uC694. \uB2E8\uACC4\uBCC4 \uC561\uC158 \uAC00\uC774\uB4DC\uB97C \uC81C\uACF5\uD558\uACE0, \uCD08\uBCF4\uC790\uAC00 \uBC14\uB85C \uC2E4\uD589\uD560 \uC218 \uC788\uB3C4\uB85D \uAD6C\uCCB4\uC801\uC73C\uB85C \uC124\uBA85\uD558\uC138\uC694.",
  medium: "\uD575\uC2EC \uC778\uC0AC\uC774\uD2B8\uB97C \uC911\uC2EC\uC73C\uB85C \uB2F5\uBCC0\uD558\uB418, \uD544\uC694\uD55C \uACBD\uC6B0 \uAC04\uB7B5\uD55C \uBC30\uACBD \uC124\uBA85\uC744 \uCD94\uAC00\uD558\uC138\uC694. \uB370\uC774\uD130 \uAE30\uBC18 \uC561\uC158 \uC544\uC774\uD15C\uC744 \uC81C\uC2DC\uD558\uC138\uC694.",
  low: "\uB370\uC774\uD130\uB97C \uAC04\uACB0\uD558\uAC8C \uC81C\uC2DC\uD558\uACE0 \uBD88\uD544\uC694\uD55C \uC124\uBA85\uC744 \uC0DD\uB7B5\uD558\uC138\uC694. \uC804\uBB38\uAC00 \uC218\uC900\uC758 \uBD84\uC11D\uACFC \uCEE4\uC2A4\uD140 \uAC00\uB2A5\uD55C \uC778\uC0AC\uC774\uD2B8\uB97C \uC81C\uACF5\uD558\uC138\uC694."
};
function buildPersonalizedSystemPrompt(agent, persona) {
  if (!persona) {
    return agent.systemPrompt;
  }
  const densityInstruction = HELP_DENSITY_INSTRUCTIONS[persona.helpDensity];
  const personaContext = [
    "",
    "---",
    "## \uC0AC\uC6A9\uC790 \uCEE8\uD14D\uC2A4\uD2B8",
    `\uC0AC\uC6A9\uC790 \uD398\uB974\uC18C\uB098: ${persona.name} (${persona.characterName})`,
    `\uC0AC\uC6A9\uC790 \uBAA9\uC801: ${persona.primaryGoal}`,
    `\uC124\uBA85 \uBC00\uB3C4: ${persona.helpDensity} \u2192 ${densityInstruction}`,
    "---"
  ].join("\n");
  return agent.systemPrompt + personaContext;
}
function buildOnboardingSystemPrompt(basePrompt, onboardingState, turnCount = 0) {
  if (onboardingState === "activated") {
    return basePrompt;
  }
  const additions = [];
  if (onboardingState === "first-chat") {
    additions.push(
      "",
      "## \uC628\uBCF4\uB529 \uC9C0\uC2DC (\uCCAB \uB300\uD654)",
      "- \uC804\uBB38 \uC6A9\uC5B4\uAC00 \uB098\uC62C \uACBD\uC6B0 \uBC18\uB4DC\uC2DC \uAD04\uD638 \uC548\uC5D0 \uC26C\uC6B4 \uC124\uBA85\uC744 \uCD94\uAC00\uD558\uC138\uC694.",
      "- \uB2F5\uBCC0\uC5D0 KPI \uCE74\uB4DC \uC704\uC82F\uC744 \uBC18\uB4DC\uC2DC 1\uAC1C \uC774\uC0C1 \uD3EC\uD568\uD558\uC138\uC694.",
      "- \uB2F5\uBCC0 \uB9C8\uC9C0\uB9C9\uC5D0 \uB2E4\uC74C \uC561\uC158\uC744 \uC720\uB3C4\uD558\uB294 CTA \uBC84\uD2BC\uC744 1~2\uAC1C \uC81C\uC548\uD558\uC138\uC694.",
      "- \uC0AC\uC6A9\uC790\uAC00 \uC9C1\uC811 \uC2E4\uD589\uD560 \uC218 \uC788\uB294 \uAD6C\uCCB4\uC801\uC778 \uB2E4\uC74C \uB2E8\uACC4\uB97C \uC548\uB0B4\uD558\uC138\uC694."
    );
  } else if (onboardingState === "checklist-active") {
    if (turnCount > 0 && turnCount % 3 === 0) {
      additions.push(
        "",
        "## \uC628\uBCF4\uB529 \uC9C0\uC2DC (\uCCB4\uD06C\uB9AC\uC2A4\uD2B8)",
        "- \uC774\uBC88 \uB2F5\uBCC0 \uB9C8\uC9C0\uB9C9\uC5D0 \uB2E4\uC74C \uCCB4\uD06C\uB9AC\uC2A4\uD2B8 \uD56D\uBAA9\uC744 \uC790\uC5F0\uC2A4\uB7FD\uAC8C \uC81C\uC548\uD558\uC138\uC694.",
        "- \uC608: '\uB2E4\uC74C\uC73C\uB85C [\uD56D\uBAA9\uBA85]\uC744 \uD574\uBCF4\uC2DC\uACA0\uC5B4\uC694? \uC9C0\uAE08 \uBC14\uB85C \uB3C4\uC640\uB4DC\uB9B4 \uC218 \uC788\uC5B4\uC694!'"
      );
    }
  }
  if (additions.length === 0) return basePrompt;
  return basePrompt + additions.join("\n");
}
export {
  ONBOARDING_QUESTIONS,
  PERSONA_AGENT_DEFAULTS,
  PERSONA_IDS,
  PERSONA_LAYOUT_DEFAULTS,
  PERSONA_REGISTRY,
  buildOnboardingSystemPrompt,
  buildPersonalizedSystemPrompt,
  classifyPersona,
  clearPersona,
  getActivationCriteriaForPersona,
  getAllPersonas,
  getCurrentPersona,
  getPersona,
  getPersonaAgentId,
  getPersonaLayoutMode,
  setCurrentPersona
};
//# sourceMappingURL=index.js.map